import { UserGroup } from '@/shared/utils/get-group';
import {
  Bell,
  Building2,
  Cable,
  ClipboardList,
  DollarSign,
  FileSearch,
  Handshake,
  Home,
  Layers,
  LucideIcon,
  Settings,
  Shield,
  ShieldCheck,
  SquarePen,
  UsersRound,
  Wallet,
} from 'lucide-react';

export interface SubMenuItem {
  id: string;
  label: string;
  icon?: LucideIcon;
  permissions?: string[];
  groups?: string[];
}

export interface MenuItem {
  id: string;
  icon: LucideIcon;
  label: string;
  subItems?: SubMenuItem[];
  permissions?: string[];
  groups?: string[];
}

export const menuItems: MenuItem[] = [
  { id: '/dashboard', icon: Home, label: 'Página Inicial' },
  {
    id: '/advisories',
    icon: Building2,
    label: 'Assessorias',
    permissions: ['parties.advisories.read'],
  },
  {
    id: '/quotes',
    icon: Handshake,
    label: 'Cotações',
    permissions: ['policies.quotes.read'],
  },
  // RD Equipamentos deixou de ter item exclusivo: agora aparece nas listas
  // unificadas (Cotações/Propostas/Apólices) via filtro de produto, e é cotado
  // pelo "Escolher Produto". A lista dedicada /quotes/rd-equipamentos foi
  // removida; só resta a rota de impressão de apólice RD (fora do menu).
  {
    id: '/proposals',
    icon: ClipboardList,
    label: 'Propostas',
    permissions: ['policies.proposals.read'],
  },
  {
    id: '#underwriting-analyses',
    icon: Layers,
    label: 'Análises de Subscrição',
    subItems: [
      {
        id: '/proposal-analyses',
        icon: FileSearch,
        label: 'Análise de Proposta',
        groups: [
          UserGroup.INSURER_UNDERWRITER,
          UserGroup.INSURER_ADMINISTRATOR,
        ],
      },
      {
        id: '/analyses',
        icon: SquarePen,
        label: 'Análise de Cotação',
        groups: [
          UserGroup.INSURER_UNDERWRITER,
          UserGroup.INSURER_ADMINISTRATOR,
        ],
      },
      {
        id: '/inspections',
        icon: ShieldCheck,
        label: 'Análise de Inspeção',
        permissions: ['policies.inspections.read'],
      },
    ],
  },
  {
    id: '/policies',
    icon: Shield,
    label: 'Apólices',
    permissions: ['policies.emissions.read'],
  },
  {
    id: '/notifications',
    icon: Bell,
    label: 'Notificações',
    // A corretora vê o próprio feed; a seguradora vê o da corretora
    // selecionada no header (a tela pede a seleção quando não há nenhuma).
    // Assessoria fica de fora nesta fase: nada é gravado para ela.
    groups: [
      UserGroup.BROKER_MASTER,
      UserGroup.BROKER_BROKER,
      UserGroup.INSURER_ADMINISTRATOR,
      UserGroup.INSURER_CUSTOMER_SUPPORT,
      UserGroup.INSURER_UNDERWRITER,
      UserGroup.INSURER_COMMERCIAL_MANAGER,
      UserGroup.INSURER_SALES_EXECUTIVE,
      UserGroup.INSURER_COMMERCIAL_ASSISTANT,
      UserGroup.INSURER_FINANCE,
    ],
  },
  {
    id: '/reports',
    icon: Wallet,
    label: 'Gestão de Carteira',
    permissions: ['reports.read'],
  },
  {
    id: '/financial',
    icon: DollarSign,
    label: 'Gestão Financeira',
  },
  {
    id: '/brokers',
    icon: UsersRound,
    label: 'Corretores',
    permissions: ['parties.brokers.read'],
  },
  {
    id: '/integrations',
    icon: Cable,
    label: 'Integrações',
    permissions: ['policies.integrations.read'],
  },
  /*  {
    id: '#comercial',
    icon: Handshake,
    label: 'Comercial',
    subItems: [
      { id: '/quotes/products', label: 'Cotação' },
      { id: '/propostas', label: 'Propostas' },
      { id: '/nossos-produtos', label: 'Nossos Produtos' },
    ],
  },
  { id: '#carteira', icon: Users, label: 'Carteira' },
  { id: '#apolice', icon: Shield, label: 'Apólice' },
  { id: '#sinistros', icon: AlertTriangle, label: 'Sinistros' },
  { id: '#documentos', icon: FileText, label: 'Documentos' },
  { id: '#financeiro', icon: DollarSign, label: 'Financeiro' },
  { id: '#relatorios', icon: BarChart3, label: 'Relatórios' },
  {
    id: '/support',
    icon: MessageCircle,
    label: 'Suporte',
  }, */
];

export const settingsMenuItem: MenuItem = {
  id: '/settings',
  icon: Settings,
  label: 'Configurações',
};
